module.exports = __webpack_public_path__ + "img/solid_waste.f6d25a55.svg";